import React from "react";
//#region redux
import { useSelector } from "react-redux";
import { AppState } from "store";
//#endregion
//#region types
import { TranslationKeys } from "translations";
import { FAQConstants, IconDefinitionConstants } from "utils/constants";
//#endregion
//#region components
import { GroupSection, FormFieldLayout } from "components/common/wintForms";
import { ActionLinkButton, Icon, StaticInfoMessage, useCompanyInvoiceMail } from "components/common";
import CopyButton from "components/common/buttons/copyButton";
import { Grid } from "@mui/material";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import { LocalizationHelperInstance, UtilsHelper } from "utils/helpers";
import { DisplayType } from "models/enums/style";

const IncomingInvoiceSection: React.FC = () => {
  const billingAddress = useSelector((state: AppState) =>
    UtilsHelper.getFormattedCompanyAddress(state.auth.selectedCompany.billingAddress)
  );
  const companyInvoiceMail = useCompanyInvoiceMail();

  const gotoInfoLink = (link?: string) => {
    window.open(link, "_blank");
  };

  const learnMoreLink = (
    <ActionLinkButton
      className={cssExports.animatedLink}
      onClick={gotoInfoLink.bind(
        null,
        `${FAQConstants.FAQUrl}/${FAQConstants.FAQPageUrl}/${FAQConstants.SupplierInvoiceUrl}`
      )}
      endIcon={<Icon icon={IconDefinitionConstants.WArrowSmallRight} displayType={DisplayType.Info} />}
    >
      {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.IncomingInvoice.LearnMoreLink)}
    </ActionLinkButton>
  );

  return (
    <GroupSection header="" className={cssExports.noTitle}>
      <FormFieldLayout direction="vertical">
        <StaticInfoMessage>
          {companyInvoiceMail ? (
            <Grid container direction="column" rowGap={1.5}>
              <Grid item>
                {LocalizationHelperInstance.getFormattedMessage(
                  TranslationKeys.IncomingInvoice.CreateFromUIOnboardedInfo
                )}
              </Grid>
              <Grid item>
                {LocalizationHelperInstance.getFormattedMessage(
                  TranslationKeys.IncomingInvoice.CreateFromUIOnboardedTipPart1
                )}
                <CopyButton copyText={companyInvoiceMail} showCopyIcon>
                  {companyInvoiceMail}
                </CopyButton>
                {LocalizationHelperInstance.getFormattedMessage(
                  TranslationKeys.IncomingInvoice.CreateFromUIOnboardedTipPart2
                )}
              </Grid>
              <Grid item>{learnMoreLink}</Grid>
            </Grid>
          ) : (
            <Grid item container className={cssExports.whiteSpacePre}>
              {LocalizationHelperInstance.getFormattedMessage(
                TranslationKeys.IncomingInvoice.CreateFromUIWarning,
                undefined,
                {
                  customerInvoiceAddress: billingAddress,
                }
              )}
              {learnMoreLink}
            </Grid>
          )}
        </StaticInfoMessage>
      </FormFieldLayout>
    </GroupSection>
  );
};
export default IncomingInvoiceSection;
